import React, { ComponentProps } from 'react';

import { CheckBoxParam, Form, Row, SonForm, SubmitButton, Switch, useForm } from '../../../_lib/Form2';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type PageInstantReactionEditViewProps = {
  toggleForm: SonForm<CheckBoxParam<'active'>>;
};

function PageInstantReactionEdit({ toggleForm }: PageInstantReactionEditViewProps) {
  const { t } = useSonTranslation('PageInstantReaction');
  const { onSuccess } = useViewContext();
  const { formProps, params, fetchState } = useForm({ form: toggleForm, onSuccess });

  const activeParams = params.getByName('active');

  return (
    <Form {...formProps}>
      <Row>
        <Switch label={t('editView.switchLabel')} param={activeParams} />
      </Row>
      <SubmitButton
        buttonLabel={t('editView.submitButton')}
        messageSuccess={t('editView.status.success')}
        messageSending={t('editView.status.sending')}
        messageFail={t('editView.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const PageInstantReactionEditView = asFetchableView(PageInstantReactionEdit);
export type PageInstantReactionEditView = ComponentProps<typeof PageInstantReactionEditView>;
